import React, { ReactNode } from 'react';
import cn from 'clsx';

import Button from '../../library/button/button';
import Image from '../../library/image/image';
import Typography from '../../library/typography/typography';

import styles from './easy-pay-option.scss';

interface EasyPayOptionProps {
  className?: string;
  imageAlt: string;
  imageUrl: string;
  linkText: string;
  message: ReactNode;
  onClick: () => void;
  showImageAfterMessage?: boolean;
  showLinkAsCTA?: boolean;
  title?: string;
}

function EasyPayOption(props: EasyPayOptionProps) {
  const {
    className = '',
    imageAlt,
    imageUrl,
    linkText,
    message,
    onClick,
    showImageAfterMessage,
    showLinkAsCTA,
    title
  } = props;

  return (
    <aside className={cn(styles['container'], `easy-pay-option ${className}`)}>
      {imageUrl && !showImageAfterMessage && (
        <Image
          alt={imageAlt}
          className={cn(styles['image'], 'easy-pay-option__image')}
          loading="lazy"
          src={imageUrl}
        />
      )}
      <div
        className={cn(
          `${styles['description-container']} ${
            showLinkAsCTA ? styles['description-container-cta'] : ''
          }`,
          'easy-pay-option__description-container'
        )}
      >
        <div
          className={cn(styles['description'], 'easy-pay-option__description')}
        >
          {title && (
            <Typography
              className={cn(styles['title'], 'easy-pay-option__title')}
              tag="p"
              variant="H6"
            >
              {title}
            </Typography>
          )}
          <Typography
            className={cn(styles['message'], 'easy-pay-option__message')}
            tag="p"
            weight="bold"
          >
            {message}
          </Typography>
        </div>
        {linkText && !showLinkAsCTA && (
          <Button
            className={cn(styles['link'], 'easy-pay-option__link')}
            onClick={onClick}
            size="regular"
          >
            {linkText}
          </Button>
        )}
        {imageUrl && showImageAfterMessage && (
          <div data-testid="image-after">
            <Image
              alt={imageAlt}
              className={cn(styles['image'], 'easy-pay-option__image')}
              loading="lazy"
              src={imageUrl}
            />
          </div>
        )}
      </div>
      {linkText && showLinkAsCTA && (
        <Button
          className={styles['cta']}
          isSecondary={showLinkAsCTA}
          onClick={onClick}
          size="regular"
        >
          {linkText}
        </Button>
      )}
    </aside>
  );
}

export default EasyPayOption;
